var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cq-page"},[_c('query-result',{key:_vm.routeKey,attrs:{"api":_vm.api,"payload":_vm.payload,"template-id":_vm.templateId,"template-name":_vm.templateName}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d90b72","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--5!./src/component/data-grid/custom-query/pages/result-page.vue
// module id = 140
// module chunks = 0